<template>
  <div class="loading" v-show="isShow.isLDShow">
    <div class="logo"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: {
      type: Object
    }
  },
  data () {
    return {
      loadingNum: 0,
      imgArr: [],
      preLoadImg: [
        { src: require('./logo.png') },
        { src: require('../page-kv/bg2.jpg') },
        { src: require('../page-kv/btn-make.png') },
        { src: require('../page-kv/1.gif') },
        { src: require('../page-kv/2.gif') },
        { src: require('../page-kv/3.gif') },
        { src: require('../page-kv/4.gif') },
        { src: require('../page-kv/5.gif') },
        { src: require('../page-two/btn-again.png') },
        { src: require('../page-two/btn-share.png') },
        { src: require('../page-two/fn-bg.jpg') },
        { src: require('../page-two/mask-share.png') },
        {src: require('../page-one/img/arrow.png')},
        {src: require('../page-one/img/bg.jpg')},
        {src: require('../page-one/img/btn-camera.png')},
        {src: require('../page-one/img/btn-del.png')},
        {src: require('../page-one/img/btn-resize.png')},
        {src: require('../page-one/img/child.png')},
        {src: require('../page-one/img/child1.png')},
        {src: require('../page-one/img/child2.png')},
        {src: require('../page-one/img/child3.png')},
        {src: require('../page-one/img/child4.png')},
        {src: require('../page-one/img/coup1.png')},
        {src: require('../page-one/img/coup11.png')},
        {src: require('../page-one/img/coup12.png')},
        {src: require('../page-one/img/coup13.png')},
        {src: require('../page-one/img/coup14.png')},
        {src: require('../page-one/img/coup2.png')},
        {src: require('../page-one/img/coup21.png')},
        {src: require('../page-one/img/coup22.png')},
        {src: require('../page-one/img/coup23.png')},
        {src: require('../page-one/img/coup24.png')},
        {src: require('../page-one/img/coup3.png')},
        {src: require('../page-one/img/coup31.png')},
        {src: require('../page-one/img/coup32.png')},
        {src: require('../page-one/img/coup33.png')},
        {src: require('../page-one/img/coup34.png')},
        {src: require('../page-one/img/coup4.png')},
        {src: require('../page-one/img/coup41.png')},
        {src: require('../page-one/img/coup42.png')},
        {src: require('../page-one/img/coup43.png')},
        {src: require('../page-one/img/coup44.png')},
        {src: require('../page-one/img/couplet.png')},
        {src: require('../page-one/img/fn-text.jpg')},
        {src: require('../page-one/img/gfc-thumb1.png')},
        {src: require('../page-one/img/gfc-thumb2.png')},
        {src: require('../page-one/img/gmc-thumb1.png')},
        {src: require('../page-one/img/gmc-thumb2.png')},
        {src: require('../page-one/img/grand-f1c.png')},
        {src: require('../page-one/img/grand-f1h.png')},
        {src: require('../page-one/img/grand-f2c.png')},
        {src: require('../page-one/img/grand-f2h.png')},
        {src: require('../page-one/img/grand-m1c.png')},
        {src: require('../page-one/img/grand-m1h.png')},
        {src: require('../page-one/img/grand-m2c.png')},
        {src: require('../page-one/img/grand-m2h.png')},
        {src: require('../page-one/img/h-thumb1.png')},
        {src: require('../page-one/img/h-thumb2.png')},
        {src: require('../page-one/img/h1.png')},
        {src: require('../page-one/img/h2.png')},
        {src: require('../page-one/img/h3.png')},
        {src: require('../page-one/img/h4.png')},
        {src: require('../page-one/img/h5.png')},
        {src: require('../page-one/img/h6.png')},
        {src: require('../page-one/img/human.png')},
        {src: require('../page-one/img/parent-f1c.png')},
        {src: require('../page-one/img/parent-f1h.png')},
        {src: require('../page-one/img/parent-f2c.png')},
        {src: require('../page-one/img/parent-f2h.png')},
        {src: require('../page-one/img/parent-m1c.png')},
        {src: require('../page-one/img/parent-m1h.png')},
        {src: require('../page-one/img/parent-m2c.png')},
        {src: require('../page-one/img/parent-m2h.png')},
        {src: require('../page-one/img/pet1.png')},
        {src: require('../page-one/img/pet2.png')},
        {src: require('../page-one/img/pet3.png')},
        {src: require('../page-one/img/pet4.png')},
        {src: require('../page-one/img/pet5.png')},
        {src: require('../page-one/img/pet.png')},
        {src: require('../page-one/img/tut-addNew.png')},
        {src: require('../page-one/img/tut-again1.png')},
        {src: require('../page-one/img/tut-again2.png')},
        {src: require('../page-one/img/w1.png')},
        {src: require('../page-one/img/w2.png')},
        {src: require('../page-one/img/w3.png')},
        {src: require('../page-one/img/w4.png')},
        {src: require('../page-one/img/w5.png')},
        {src: require('../page-one/img/pfc-thumb1.png')},
        {src: require('../page-one/img/pfc-thumb2.png')},
        {src: require('../page-one/img/pmc-thumb1.png')},
        {src: require('../page-one/img/pmc-thumb2.png')},
        {src: require('../page-one/img/tutorial-hand.png')},
        {src: require('../page-one/img/yfc-thumb1.png')},
        {src: require('../page-one/img/yfc-thumb2.png')},
        {src: require('../page-one/img/yfc-thumb3.png')},
        {src: require('../page-one/img/yfc-thumb4.png')},
        {src: require('../page-one/img/yfc-thumb5.png')},
        {src: require('../page-one/img/yfc-thumb6.png')},
        {src: require('../page-one/img/ymc-thumb1.png')},
        {src: require('../page-one/img/ymc-thumb2.png')},
        {src: require('../page-one/img/ymc-thumb3.png')},
        {src: require('../page-one/img/ymc-thumb4.png')},
        {src: require('../page-one/img/ymc-thumb5.png')},
        {src: require('../page-one/img/ymc-thumb6.png')},
        {src: require('../page-one/img/yfh-thumb1.png')},
        {src: require('../page-one/img/yfh-thumb2.png')},
        {src: require('../page-one/img/yfh-thumb3.png')},
        {src: require('../page-one/img/yfh-thumb4.png')},
        {src: require('../page-one/img/yfh-thumb5.png')},
        {src: require('../page-one/img/yfh-thumb6.png')},
        {src: require('../page-one/img/pmh-thumb1.png')},
        {src: require('../page-one/img/pmh-thumb2.png')},
        {src: require('../page-one/img/pfh-thumb1.png')},
        {src: require('../page-one/img/pfh-thumb2.png')},
        {src: require('../page-one/img/gmh-thumb1.png')},
        {src: require('../page-one/img/gmh-thumb2.png')},
        {src: require('../page-one/img/gfh-thumb1.png')},
        {src: require('../page-one/img/gfh-thumb2.png')},
        {src: require('../page-one/img/young-f1c.png')},
        {src: require('../page-one/img/young-f2c.png')},
        {src: require('../page-one/img/young-f3c.png')},
        {src: require('../page-one/img/young-f4c.png')},
        {src: require('../page-one/img/young-f5c.png')},
        {src: require('../page-one/img/young-f6c.png')},
        {src: require('../page-one/img/young-f1h.png')},
        {src: require('../page-one/img/young-f2h.png')},
        {src: require('../page-one/img/young-f3h.png')},
        {src: require('../page-one/img/young-f4h.png')},
        {src: require('../page-one/img/young-f5h.png')},
        {src: require('../page-one/img/young-f6h.png')},
        {src: require('../page-one/img/young-m1c.png')},
        {src: require('../page-one/img/young-m2c.png')},
        {src: require('../page-one/img/young-m3c.png')},
        {src: require('../page-one/img/young-m4c.png')},
        {src: require('../page-one/img/young-m5c.png')},
        {src: require('../page-one/img/young-m6c.png')},
        {src: require('../page-one/img/young-m1h.png')},
        {src: require('../page-one/img/young-m2h.png')},
        {src: require('../page-one/img/young-m3h.png')},
        {src: require('../page-one/img/young-m4h.png')},
        {src: require('../page-one/img/young-m5h.png')},
        {src: require('../page-one/img/young-m6h.png')},
      ]
    }
  },
  methods: {
    generateId (index) {
      return 'mImg' + index
    },
    go () {
      this.isShow.isLDShow = false
      this.isShow.isKVShow = true
    },
    loadNextImg(imgID){
      const _this = this
      const len = this.preLoadImg.length
      const curSrc = this.preLoadImg[imgID].src
      let curImg = new Image()
      curImg.onload = function () {
        imgID++
        _this.loadingNum = parseInt(imgID / len * 100)
        if (imgID < len) {
          _this.loadNextImg(imgID)
        } else {
          // console.log('completed')
          _this.go()
        }
      }
      curImg.src = curSrc
    }
  },
  mounted () {
    let imgID = 0
    setTimeout(() => {
      this.loadNextImg(imgID)
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
  .logo {
    width: 9.375rem /* 150/16 */;
    height: 12.5rem /* 200/16 */;
    background-image: url(./loading.gif);
    background-size: cover;
    background-repeat: no-repeat;
  }
}
</style>
